
<template>
    <div class="mem_fields" v-if="!is_mem_load">
        <mem_draw_field
            key="mem_number"
            :field_val="mem_number" field_type="number" field_name="Номер">
        </mem_draw_field>
        
        <mem_draw_field
            key="added"
            :field_val="mem_date" field_type="added" field_name="Дата створення">
        </mem_draw_field>
        
        <mem_draw_field
            key="mem_question_title"
            :field_val="mem_question_title" field_type="mem_question_title" field_name="Питання">
        </mem_draw_field>
        
        <mem_draw_field
            key="title"
            :can_edit="true"
            @title_edit="edit_title"
            :field_val="mem_title"
            field_type="title"
            field_name="Тема">
        </mem_draw_field>
        
        <mem_draw_field
            key="mem_organization"
            :field_val="mem_organization_title" field_type="mem_organization_title" field_name="Організація">
        </mem_draw_field>
        
        <mem_draw_field
            key="mem_service"
            :field_val="mem_service_title" field_type="mem_service_title" field_name="Служба">
        </mem_draw_field>
        
        
        <div class="mem_links" >
            <div class="form-group ">
                <div class="control-label">
                    <label id="jform_reasons-lbl" for="jform_reasons">
                        Документ підстава
                    </label>
                </div>
                
                <div class="simple_text" >
                    <div class="edit_text  d-inline-block pl-1 cursor-pointer" @click="edit_links">
                        <fa :icon="faEdit"/>
                    </div>
                    <div class="d-block" v-for="item in mem_links" v-if="mem_links.length > 0">
                        <a class="mem_link mt-2" target="_blank" :href="item.link" >
                            {{item.title}}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {mapGetters} from "vuex";
import Mem_draw_field from "./helpers/mem_draw_field.vue";
import Fa from 'vue-fa'
import { faEdit } from '@fortawesome/free-solid-svg-icons'

export default {
    name: "mem_block_left",
    components: {Mem_draw_field,  Fa},
    data() {
        return {
            faEdit
        }
    },
    methods : {
        edit_title() {
            this.$emit('edit_title');
        },
        
        edit_links() {
            this.$emit('edit_links');
        },
    },
    
    computed: {
        ...mapGetters({
            'memorandum': "memorandum_inside/getMemorandum",
            'is_mem_load': "memorandum_inside/is_load"
        }),
        
        mem_number() {
            if(this.memorandum.hasOwnProperty("number")) {
                return this.memorandum.number;
            }
            return "";
        },
        
        
        mem_title () {
            if(this.memorandum.hasOwnProperty("title")) {
                return this.memorandum.title;
            }
            return "";
        },
        
        mem_date () {
            if(this.memorandum.hasOwnProperty("date_added")) {
                return this.memorandum.date_added;
            }
            return "";
        },
        
        mem_organization() {
            if(this.memorandum.hasOwnProperty("organization")) {
                return this.memorandum.organization;
            }
            
            return {"title" : ""};
        },
        
        mem_organization_title () {
            return this.mem_organization.title;
        },
        
        mem_service() {
            if(this.memorandum.hasOwnProperty("service")) {
                return this.memorandum.service;
            }
            
            return {"title" : ""};
        },
        
        mem_service_title () {
            return this.mem_service.title;
        },
        
        mem_question() {
            if(this.memorandum.hasOwnProperty("question")) {
                return this.memorandum.question;
            }
            
            return {"title" : ""};
        },
        
        mem_question_title () {
            return this.mem_question.title;
        },
        
        mem_links() {
            if(this.memorandum.hasOwnProperty("links_docs")) {
                return this.memorandum.links_docs;
            }
            
            return [];
        },
        
        
        
    },
}
</script>

<style scoped>

</style>